<template lang="pug">
  #CustomerTagModel.CustomerModel.CustomerModel-tagModel(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .p-3
      .row.align-items-start.mb-2
        .col-10
          h2.mb-0 {{ title }}
        .col-2
          img.rounded-circle.closeIcon(
            v-lazy="iconUrl.IconClose",
            fluid,
            alt="Close Icon",
            @click="closeModel()"
          )
      .content
        multiselect(
          v-model="userLabels",
          tag-placeholder="",
          placeholder="輸入文字搜尋標籤",
          selectLabel="",
          :showLabels="false",
          deselectLabel="點擊移除標籤",
          selectedLabel="已選擇",
          label="tag_name",
          track-by="tag_key",
          group-values="tag",
          group-label="type",
          :options="tagsOption",
          :multiple="true",
          :taggable="true",
          noOptions="無標籤"
        )
          template(slot="Label", slot-scope='{ tags }')
          template(slot="noOptions")
            strong 請按 Enter 新增標籤
    .row.no-gutters.py-5
      .col-6
        button.btn.btn-block.btn-light(
          type="button",
          @click="closeModel()",
          class="rounded-0 border border-gray"
        ) 返回上頁
      .col-6
        button.btn.btn-block.btn-primary(
          type="button",
          @click="submitHandler()",
          class="rounded-0 border border-gray"
        ) 儲存
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

const _ = require('lodash');

export default {
  name: 'TagModel',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      user: null,
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      time: +new Date(),
      userLabels: [],
      tagsOption: []
    };
  },
  mounted() {
    this.$EventBus.$on('openTagModel', (user) => {
      this.initHandler(user);
    });
  },
  methods: {
    initHandler(user) {
      const vm = this;
      vm.tagsOption = _.cloneDeep(vm.tags);
      vm.userLabels = _.cloneDeep(vm.memberTags);
      vm.$set(vm, 'user', user);
      vm.openModel();
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      const vm = this;
      if (!_.isEqual(_.sortBy(vm.userLabels), _.sortBy(vm.memberTags))) {
        vm.$swal.fire({
          title: '',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          confirmButtonText: '儲存編輯',
          cancelButtonText: '繼續編輯',
          reverseButtons: false,
          showDenyButton: true,
          denyButtonText: '放棄編輯',
          customClass: {
            confirmButton: 'btn btn-primary px-5 d-block btn-block',
            cancelButton: 'btn btn-gray px-5 d-block btn-block',
            denyButton: 'btn btn-danger px-5 d-block btn-block'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            const store_info = {
              member_uuid: vm.user.member_uuid,
              tags: vm.userLabels
            };
            // 儲存
            vm.$store.dispatch('sa_reservation/storeTagsHandler', store_info)
              .then(() => {
                vm.$emit('closeModelHandler');
                vm.showModel = false;
                vm.$snotify.success(null, '儲存成功');
              });
          } else if (result.isDenied) {
            vm.$emit('closeModelHandler');
            // 不儲存離開
            vm.showModel = false;
          }
        });
      } else {
        vm.$emit('closeModelHandler');
        vm.showModel = false;
      }
    },
    // 儲存
    submitHandler() {
      const vm = this;
      // 儲存
      vm.$store.dispatch('sa_reservation/storeTagsHandler', {
        member_uuid: vm.user.member_uuid,
        tags: vm.userLabels
      })
        .then(() => {
          vm.$emit('closeModelHandler');
          vm.showModel = false;
          vm.$snotify.success(null, '儲存成功');
        });
    },
    addLabelHandler(tag_name) {
      const vm = this;
      vm.userLabels.push({
        tag_name,
        tag_id: null,
        type: 'new',
        tag_key: vm.time + 1
      });
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openTagModel');
  },
  computed: {
    ...mapState({
      tags: (state) => state.sa_reservation.tags,
      memberTags: (state) => state.sa_reservation.memberTags
    })
  }
};
</script>

<style>

</style>
